/**
 * Returns a zip entry name that does not collide with names already used.
 * photo.jpg → photo_2.jpg → photo_3.jpg, etc.
 */
function makeUniqueZipName(name: string, usedNames: Set<string>): string {
  if (!usedNames.has(name)) {
    usedNames.add(name);
    return name;
  }

  const dot = name.lastIndexOf(".");
  const base = dot > 0 ? name.slice(0, dot) : name;
  const ext = dot > 0 ? name.slice(dot) : "";

  let suffix = 2;
  let candidate = `${base}_${suffix}${ext}`;
  while (usedNames.has(candidate)) {
    suffix += 1;
    candidate = `${base}_${suffix}${ext}`;
  }

  usedNames.add(candidate);
  return candidate;
}

export default makeUniqueZipName;
